<template>
  <Modal :id="'cmp-add-products'" @cancelled="onCancel">
    <!-- <template slot="header">{{ $dft.snakeCaseToWords(ppkey) }}</template> -->
    <template slot="header"
      >{{$t('add_products')}}</template
    >

    <template slot="body">
      <div class="body-container">
        <div class="ut-flex">
          <div class="product-search">
            <InputField
              :id="'product_search'"
              :value="searchString"
              :placeholder="$t('search')"
              :config="{
                borderStyle: 'bottom',
                width: '128px'
              }"
              @keyup="onSearchInputKeyup"
            ></InputField>
          </div>
          <div class="dropdown-panel-area ut-flex">
            <div class="filter-dropdown">
              <Dropdown
                :options="formatsTV"
                v-if="formatsTV && formatsTV.length > 0"
                :selected="formatsTV.find(f => f.value == format_id)"
                :placeholder="$t('select_format')"
                deselect
                borderbottom
                @selectedChange="e => onDropdownChange('format_id', e)"
              ></Dropdown>
            </div>
            <div class="filter-dropdown">
              <Dropdown
                :options="labelsTV"
                v-if="labelsTV && labelsTV.length > 0"
                :selected="labelsTV.find(l => l.value == label_id)"
                :placeholder="$t('select_label')"
                deselect
                borderbottom
                @selectedChange="e => onDropdownChange('label_id', e)"
              ></Dropdown>
            </div>
          </div>
        </div>
        <NTable
          class="h1 dbox1"
          id="catalog-product_groups-add_products"
          :config="tableConfig"
          :headers="headers"
          :items="list"
        >
          <template v-slot:item="{ item, tdcon }">
            <tr>
              <td v-bind="tdcon('catalog_no')">
                <span
                  class="txtov ut-link ut-text-accent5"
                  :title="item['catalog_no']"
                >
                  {{ item["catalog_no"] }}
                </span>
              </td>
              <td v-bind="tdcon('artist')">
                <span class="txtov" :title="item['release_artist']">
                  {{ item["release_artist"] }}
                </span>
              </td>
              <td v-bind="tdcon('release_title')">
                <span class="txtov" :title="item['release_title']">
                  {{ item["release_title"] }}
                </span>
              </td>
              <td v-bind="tdcon('format')">
                <span class="txtov" :title="item['format_name']">
                  {{ item["format_name"] }}
                </span>
              </td>
              <td v-bind="tdcon('label')">
                <span class="txtov" :title="item['label_name']">
                  {{ item["label_name"] }}
                </span>
              </td>
              <td v-bind="tdcon('options')">
                <div class="dt-checkbox v2 s1">
                  <input
                    type="checkbox"
                    @click.stop="e => onProductSelected(e, item)"
                    :name="item.product_id"
                    :id="item.product_id"
                    :checked="selectedProducts.has(item.product_id)"
                  />
                  <div class="checkmark"></div>
                </div>
              </td>
            </tr>
          </template>
        </NTable>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onSelectAll">
        {{ !selectAllFlag ? $t('select_all') : $t('select_none') }}
      </button>
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button class="dt-button v1 s6" @click.stop="onAddProducts"> {{$t('ok')}} </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import NTable from "@/plugins/datatable/datatable";
import { EventHooks } from "../../../../plugins/text-field";
import { ProductGroupsService } from "../../services/product-groups.service";
import { async } from "rxjs/internal/scheduler/async";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import InputField from "@plugins/text-field/input-field";
import { createTV } from "../../../../models/text-value.model";
import { subscribeSubject } from "../../../../utility";
import { Subject } from "rxjs";

export default {
  components: {
    Modal,
    NTable,
    InputField
  },
  // props: ["selectedProduct_groupDetails"],
  data() {
    return {
      labels: [],
      formats: [],
      productList: [],

      label_id: "",
      format_id: "",
      searchString: "",
      searchSubject: new Subject(),
      selectedProducts: new Set(),

      selectAllFlag: false
    };
  },
  mounted: async function() {
    // Product-Groups Subscription
    subscribeSubject(this, this.searchSubject, () => {
      this.findProductList();
    });

    const res = await ProductGroupsService.fetchProductFormatsList();
    // console.log('Formats ', res.data);
    this.formats = res.data.formats;
    console.log("Formats array ", this.formats);

    this.labels = res.data.labels;
    console.log("Labels array ", this.labels);
  },
  computed: {
    tableConfig: function() {
      return createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      });
    },
    list: function() {
      return this.productList || [];
    },
    product_group_id: function() {
      return this.$route.params.product_group_id;
    },
    formatsTV() {
      return createTV(this.formats, "format_name", "format_id");
    },
    labelsTV() {
      return createTV(this.labels, "label_name", "label_id").filter(
        e => e.text != ""
      );
    },
    headers: function() {
      return [
        createTableHeader("catalog_no", { fw: 700 }),
        createTableHeader("artist"),
        createTableHeader("release_title", { text: "Title" }),
        createTableHeader("format"),
        createTableHeader("label"),
        createTableHeader("options", { text: "Add", mw: 35 })
      ];
    }
  },
  methods: {
    findProductList: function() {
      ProductGroupsService.fetchProductFilterList(
        this.product_group_id,
        this.searchString,
        this.label_id,
        this.format_id
      ).then(productList => {
        console.log(productList);
        this.productList = productList.data.products || [];
      });
    },
    onAddProducts: async function() {
      // console.log("OK", this.selectedProducts);
      const res = await ProductGroupsService.addProducts(
        this.product_group_id,
        `[${Array.from(this.selectedProducts).map(e => '"' + e + '"')}]`
      );
      console.log("Add Products ", res.data);
      this.$emit("added", {
        value: res.data.products
      });
    },
    onSelectAll: function() {
      if (!this.selectAllFlag) {
        this.selectedProducts = new Set(this.list.map(i => i["product_id"]));
        this.selectAllFlag = true;
      } else {
        this.selectAllFlag = false;
        this.selectedProducts = new Set();
      }
      // this.emitSelected();
    },

    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onSearchInputKeyup: function(e) {
      this.searchString = e.target.value;
      console.log(this.searchString, e.target.value);
      this.searchSubject.next(this.searchString);
    },
    onDropdownChange(name, value) {
      this[name] = value.value;
      this.findProductList();
    },
    onProductSelected: function(e, item) {
      console.log("checkbox");
      if (e.target.checked) {
        this.selectedProducts.add(item.product_id);
      } else {
        this.selectedProducts.delete(item.product_id);
      }
    }
  }
};
</script>

<style lang="scss">
.cmp-add-products {
  .product-search,
  .dropdown-panel-area {
    margin-bottom: 30px;
  }
  .product-search {
    flex: 1;
  }
  .dropdown-panel-area {
    justify-content: flex-end;
    .filter-dropdown {
      flex: 1;
      padding-right: 10px;

      &:last-child {
        padding-right: 0;
        padding-left: 10px;
      }
      .dropdown {
        width: 128px;
      }
    }
  }
  .catalog-product_groups-add_products {
    --ntable-height: 475px !important;
    border: 1px solid var(--sprt-5);
  }
}
</style>
